import styled from 'styled-components';

export const ResultPageStyles = {
  PrintItem: styled.div`
    @media print {
      margin-bottom: 95px;
    }
  `,
};
